import { createMandatoryContext } from '@change-corgi/core/react/context';

import type { UseStepStateReturn } from './hooks/useStepState';

export const {
	Context: StepStateContext,
	Provider: StepStateContextProvider,
	useContext: useStepState,
} = createMandatoryContext<UseStepStateReturn | undefined, UseStepStateReturn>(undefined, {
	name: 'StepStateContext',
	processProviderProps: ({ data, actions }) => ({ data, actions }),
});

export type UseStepState = ReturnType<typeof useStepState>;
